// extracted by mini-css-extract-plugin
module.exports = {"invalidAddressCard":"NotFound_invalidAddressCard___Fatn","textContainer":"NotFound_textContainer__3VDxR","imgContainer":"NotFound_imgContainer__3Om-1"};